import { makeStyles } from '@hawkins/styles';
export var iconStyles = function () { return ({
    /** Class name to apply to the root of the component when the size is `large` */
    large: {},
    /** Class name to apply to the root of the component when the size is `small` */
    small: {},
    /** Class name to apply to the root of the component */
    root: {},
}); };
export var useIconStyles = makeStyles(iconStyles(), { name: 'Hawkins-Icon' });
